import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import PaymentForm from '../../../component/Admin/Payment/PaymentForm';
import PanelTopSecond from '../../../component/Admin/PanelTopSecond';
import PageLayout from '../../../components/layout/PageLayout';

const PaymentDetail = ({ data }) => {
    const navigate = useNavigate();
    const { trxID } = useParams();
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    const header = {
        headers: { Authorization: `Bearer ${data.token}` },
    };

    useEffect(() => {
        setLoading(true);
        axios
            .get(`api/payment/transaction/${trxID}`, header)
            .then((response) => setItem(response.data))
            .catch(() => {
                Swal.fire('Gagal', 'Data payment tidak ditemukan.', 'error');
                navigate('/admin/payment');
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line
    }, [trxID]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        if (payload.amount) {
            payload.amount = payload.amount.toString().replace(/[^\d]/g, '');
        }

        if (!item?.trxID) return;

        setSubmitting(true);
        axios
            .patch(`api/payment/transaction/${item.trxID}`, payload, header)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Payment berhasil diupdate.',
                    timer: 1400,
                    showConfirmButton: false,
                });
                navigate('/admin/payment');
            })
            .catch((error) => {
                Swal.fire(
                    'Gagal',
                    error?.response?.data?.message || 'Tidak bisa update payment.',
                    'error',
                );
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <PageLayout loading={loading}>
            <PanelTopSecond link="/admin/payment" />
            {item ? (
                <PaymentForm
                    handleSubmit={handleSubmit}
                    item={item}
                    data={data}
                    submitting={submitting}
                    onCancel={() => navigate('/admin/payment')}
                />
            ) : null}
        </PageLayout>
    );
};

export default PaymentDetail;
